export default __webpack_public_path__ + "3d338033492276825ff075ef5fc603c9.svg";